import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { p2e } from "../../../Utils/functions";
import "./style.scss";
export const RE_DIGIT = new RegExp(/^\d+$/);
const OTP = ({ value, valueLength = 1, onChange, setForm, form, request }) => {
  const [otp, setOtp] = useState({
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
  });
  const concat = last => {
    let res = "";
    Array(5)
      .fill(1)
      .map((_ele, idx) => {
        res = res + otp[idx];
      });
    return res + last;
  };
  const handleChange = (e, idx) => {
    const nextField = document.querySelector(`input[name=field-${idx + 1}]`);
    if (otp[idx] === e.target.value) {
      nextField.focus();
    } else {
      setOtp({ ...otp, [idx]: p2e(e.target.value) });
      if (idx == 3) {
        request(concat(p2e(e.target.value)));
      }
      if (nextField !== null) {
        nextField.focus();
      }
    }
  };
  const handleDelete = (e, idx) => {
    if (e.keyCode === 8 || e.keyCode === 46) {
      e.stopPropagation();
      e.preventDefault();
      const lastField = document.querySelector(`input[name=field-${idx - 1}]`);
      setOtp({ ...otp, [idx]: "", [idx - 1]: "" });
      if (lastField !== null) {
        lastField.focus();
      }
    }
  };
  const { pathname } = useLocation();
  return (
    <div className="otp-wrapper" data-otp={pathname == "/otp"}>
      {[1, 2, 3, 4].map((digit, idx) => (
        <input
          key={idx}
          autoFocus={digit == 1}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]*"
          maxLength={1}
          className="otp-input"
          name={"field-" + idx}
          value={otp[idx]}
          // style={{ textAlign: "right" }}
          onChange={e => handleChange(e, idx)}
          onKeyDown={e => handleDelete(e, idx)}
          onClick={e => {
            e.target.select();
          }}
          onFocus={e => {
            e.target.select();
          }}
        />
      ))}
    </div>
  );
};

export default OTP;
